import { getIn, useFormikContext } from 'formik'
import { ReactElement } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Column } from 'components/v2/Column'
import Heading from 'components/v2/Heading'
import { Row } from 'components/v2/Row'
import { IInsurancePolicyFormValues } from 'features/Vehicles/types'
import { Label } from 'components/v2/Label'
import { InputDate } from 'components/v2/InputDate'
import { FilePreview, InputFile, MB } from 'components/v2/InputFile'

export const InsurancePolicyForm = (): ReactElement => {
  const intl = useIntl()
  const { values, setFieldValue, touched, errors } = useFormikContext<IInsurancePolicyFormValues>()

  return (
    <>
      <Heading.H4>
        <FormattedMessage id="vehicles.form.insurancePolicy.title" defaultMessage="Insurance policy" />
      </Heading.H4>
      <Row noMargin>
        <Column width="50%">
          <Label>
            <FormattedMessage
              id="vehicles.form.insurancePolicy.expirationDate.label"
              defaultMessage="Expiration date"
            />
          </Label>
          <InputDate
            id="insurancePolicy.expirationDate"
            intl={intl}
            placeholder="--/--/----"
            value={values.insurancePolicy.expirationDate}
            // @ts-expect-error FIXME
            onChange={(value: Date): void => {
              setFieldValue('insurancePolicy.expirationDate', value)
            }}
            touched={getIn(touched, 'insurancePolicy.expirationDate')}
            errors={getIn(errors, 'insurancePolicy.expirationDate')}
          />
        </Column>
        <Column>
          <Row>
            <Column>
              <Label>
                <FormattedMessage id="vehicles.form.insurancePolicy.document.label" defaultMessage="Document attach" />
              </Label>
              <InputFile
                onChange={(file): void => {
                  if (file instanceof File) {
                    setFieldValue('insurancePolicy.document', {
                      file,
                      name: file.name,
                      path: ''
                    })
                  }
                }}
                touched={getIn(touched, 'insurancePolicy.document')}
                errors={getIn(errors, 'insurancePolicy.document')}
                accept={{
                  'application/pdf': [],
                  'image/jpeg': [],
                  'image/jpg': [],
                  'image/png': []
                }}
                maxSize={16 * MB}
              />
            </Column>
          </Row>
          {(values.insurancePolicy.document.file || values.insurancePolicy.document.path) && (
            <Row>
              <Column>
                <FilePreview
                  file={values.insurancePolicy.document.file || (values.insurancePolicy.document.path as string)}
                  filename={values.insurancePolicy.document.name}
                  onRemoveFile={(): void => {
                    setFieldValue('insurancePolicy.document', {
                      file: '',
                      name: '',
                      path: '',
                      id: ''
                    })
                  }}
                />
              </Column>
            </Row>
          )}
        </Column>
      </Row>
    </>
  )
}
